<template>
  <v-container fluid fill-height>
      <v-layout align-center justify-center>
      <v-flex xs12 sm12 md6 lg6>
        <v-card>
            <v-toolbar dense flat >
              <v-toolbar-title>Импорт платежек
              </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
            </v-card-text>  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn block @click="open" color="primary">Импорт</v-btn>
            </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {},
    data: () => {
      return {
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// Payment.vue?b792c84e